export default "__VITE_ASSET__BLguSU9h__";